import axios from "axios";
import { getCookieValue } from "./helperServices";

import {
  Logger,
} from "../utils/logger";

const config = require("../config/index");
const JWTtoken = getCookieValue("vod-web-auth-token");

const get = (
  mode,
  requestId,
  params,
  authNeeded = true,
  reqParams = null,
  queryParams = null,
  xAuthNeeded = false,
  resAuth = "",
  contentType = "json"
) => {
  let url = `${config.envConfigs[config.env].dxl.url}${
    config[mode][requestId]
  }`;

  if (reqParams && url.indexOf("{reqParams}") !== -1) {
    url = url.replace("{reqParams}", reqParams.join("/"));
  }

  if (queryParams) {
    url = `${url}${queryParams}`;
  }

  const headers = {
    "Content-Type":
      contentType == "json"
        ? "application/json"
        : "application/x-www-form-urlencoded",
    ...params?.headers,
  };

  if (authNeeded && JWTtoken) {
    headers.Authorization = `Bearer ${JWTtoken}`;
  }
  if (xAuthNeeded && JWTtoken) {
    headers["x-auth-jwt"] = `Bearer ${JWTtoken}`;
  }
  if (resAuth && resAuth !== "") {
    headers.Authorization = `Bearer ${resAuth}`;
  }

  let opts;
  if (params) {
    if (params.headers) delete params.headers;
    opts = {
      method: "GET",
      headers,
      params,
    };
  } else {
    opts = {
      method: "GET",
      headers,
    };
  }

  let dataResults = { fail: false, response: {}, error: {} };

  return axios
    .get(url, opts)
    .then((resp) => {
      dataResults.response = resp;
      return dataResults;
    })
    .catch((error) => {

      Logger.error(
        error,
        requestId,
        {
          request: {
            mode,
            requestId,
            params: JSON.stringify(params || {}),
            authNeeded,
            reqParams: JSON.stringify(reqParams || {}),
            queryParams: queryParams || "",
            xAuthNeeded,
            resAuth,
            contentType
          },
          requestUrl: url,
          requestMethod: "GET",
          options: opts
        }
      );

      dataResults.fail = true;
      dataResults.error = error?.response;
      return dataResults;
    });
};

const post = (
  mode,
  requestId,
  body = {},
  params = null,
  authNeeded = true,
  reqParams = null,
  queryParams = null,
  contentType = "json"
) => {
  let url = `${config.envConfigs[config.env].dxl.url}${
    config[mode][requestId]
  }`;

  if (reqParams && url.indexOf("{reqParams}") !== -1) {
    url = url.replace("{reqParams}", reqParams.join("/"));
  }

  if (queryParams) {
    url = `${url}${queryParams}`;
  }

  const headers = {
    "Content-Type":
      contentType == "json"
        ? "application/json"
        : "application/x-www-form-urlencoded",
    ...params?.headers,
  };

  if (authNeeded && JWTtoken) {
    headers.Authorization = `Bearer ${JWTtoken}`;
  }

  if (requestId === "creditVettingOutcome" && JWTtoken) {
    headers["x-auth-jwt"] = `Bearer ${JWTtoken}`;
    headers["x-origin-id"] = 1;
  }

  let opts;
  if (params) {
    if (params.headers) delete params.headers;
    opts = {
      headers,
      params,
    };
  } else {
    opts = {
      headers,
    };
  }

  let dataResults = { fail: false, response: {}, error: {} };

  return axios
    .post(url, body, opts)
    .then((resp) => {
      dataResults.response = resp;
      return dataResults;
    })
    .catch((error) => {
      
      Logger.error(
        error,
        requestId,
        {
          request: {
            mode,
            requestId,
            body: JSON.stringify(body || {}),
            params: JSON.stringify(params || {}),
            authNeeded,
            reqParams: JSON.stringify(reqParams || {}),
            queryParams: queryParams || "",
            contentType
          },
          requestUrl: url,
          requestMethod: "POST",
          options: opts
        }
      );

      dataResults.fail = true;
      dataResults.error = error?.response;
      return dataResults;
    });
};

const put = (
  mode,
  requestId,
  body = {},
  params = null,
  authNeeded = true,
  reqParams = null,
  queryParams = null,
  contentType = "json"
) => {
  let url = `${config.envConfigs[config.env].dxl.url}${
    config[mode][requestId]
  }`;

  // let url = `https://apiqa.vodacom.co.za/dxl/${config[mode][requestId]}`;

  if (reqParams && url.indexOf("{reqParams}") !== -1) {
    url = url.replace("{reqParams}", reqParams.join("/"));
  }

  if (queryParams) {
    url = `${url}${queryParams}`;
  }

  const headers = {
    "Content-Type":
      contentType == "json"
        ? "application/json"
        : "application/x-www-form-urlencoded",
    ...params?.headers,
  };

  if (authNeeded && JWTtoken) {
    headers.Authorization = `Bearer ${JWTtoken}`;
  }

  let opts;
  if (params) {
    if (params.headers) delete params.headers;
    opts = {
      headers,
      params,
    };
  } else {
    opts = {
      headers,
    };
  }

  let dataResults = { fail: false, response: {}, error: {} };

  return axios
    .put(url, body, opts)
    .then((resp) => {
      dataResults.response = resp;
      return dataResults;
    })
    .catch((error) => {
      
      Logger.error(
        error,
        requestId,
        {
          request: {
            mode,
            requestId,
            body: JSON.stringify(body || {}),
            params: JSON.stringify(params || {}),
            authNeeded,
            reqParams: JSON.stringify(reqParams || {}),
            queryParams: queryParams || "",
            contentType
          },
          requestUrl: url,
          requestMethod: "PUT",
          options: opts
        }
      );

      dataResults.fail = true;
      dataResults.error = error?.response;
      return dataResults;
    });
};

const del = (
  mode,
  requestId,
  params,
  authNeeded = true,
  reqParams = null,
  queryParams = null,
  xAuthNeeded = false,
  resAuth = "",
  contentType = "json"
) => {
  let url = `${config.envConfigs[config.env].dxl.url}${
    config[mode][requestId]
  }`;

  if (reqParams && url.indexOf("{reqParams}") !== -1) {
    url = url.replace("{reqParams}", reqParams.join("/"));
  }

  if (queryParams) {
    url = `${url}${queryParams}`;
  }

  const headers = {
    "Content-Type":
      contentType == "json"
        ? "application/json"
        : "application/x-www-form-urlencoded",
    ...params?.headers,
  };

  if (authNeeded && JWTtoken) {
    headers.Authorization = `Bearer ${JWTtoken}`;
  }
  if (xAuthNeeded && JWTtoken) {
    headers["x-auth-jwt"] = `Bearer ${JWTtoken}`;
  }
  if (resAuth && resAuth !== "") {
    headers.Authorization = `Bearer ${resAuth}`;
  }

  let opts;
  if (params) {
    if (params.headers) delete params.headers;
    opts = {
      method: "DELETE",
      headers,
      params,
    };
  } else {
    opts = {
      method: "DELETE",
      headers,
    };
  }

  let dataResults = { fail: false, response: {}, error: {} };

  return axios
    .delete(url, opts)
    .then((resp) => {
      dataResults.response = resp;
      return dataResults;
    })
    .catch((error) => {

      Logger.error(
        error,
        requestId,
        {
          request: {
            mode,
            requestId,
            params: JSON.stringify(params || {}),
            authNeeded,
            reqParams: JSON.stringify(reqParams || {}),
            queryParams: queryParams || "",
            xAuthNeeded,
            resAuth,
            contentType
          },
          requestUrl: url,
          requestMethod: "DELETE",
          options: opts
        }
      );

      dataResults.fail = true;
      dataResults.error = error?.response;
      return dataResults;
    });
};

export default {
  get,
  post,
  put,
  del,
};
